import { render, staticRenderFns } from "./bsp-dicts-select.vue?vue&type=template&id=30187af7&scoped=true&"
import script from "./bsp-dicts-select.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-select.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-select.vue?vue&type=style&index=0&id=30187af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30187af7",
  null
  
)

export default component.exports